import { render, staticRenderFns } from "./UOttawaTask1Fr.vue?vue&type=template&id=21ff42dc&scoped=true&"
import script from "./UOttawaTask1Fr.vue?vue&type=script&lang=ts&"
export * from "./UOttawaTask1Fr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff42dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
